var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNotifySuccess(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "40px",
    height: "41px",
    viewBox: "0 0 40 41",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "\u6210\u529F_40dp") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "100%",
    y1: "0%",
    x2: "0%",
    y2: "100%",
    id: "linearGradient-1"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#94D59F",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#54B6C0",
    offset: "100%"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: 208,
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "0214\\u66F4\\u65B0-\\u901A\\u77E5\\u6837\\u5F0F",
    transform: "translate(-1076.000000, -324.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u7F16\\u7EC4-11\\u5907\\u4EFD-3",
    transform: "translate(1058.000000, 304.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u6210\\u529F_40dp",
    transform: "translate(18.000000, 20.500000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,0 L40,0 L40,40 L0,40 L0,0 Z M0,0 L40,0 L40,40 L0,40 L0,0 Z",
    id: "\\u5F62\\u72B6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.8307692,13.2371795 L17.6923077,23.375641 L12.1692308,17.8679487 L10,20.0371795 L17.6923077,27.7294872 L30,15.4217949 L27.8307692,13.2371795 Z M20,3.33333333 C10.8,3.33333333 3.33333333,10.8 3.33333333,20 C3.33333333,29.2 10.8,36.6666667 20,36.6666667 C29.2,36.6666667 36.6666667,29.2 36.6666667,20 C36.6666667,10.8 29.2,3.33333333 20,3.33333333 Z M20,33.3333333 C12.6333333,33.3333333 6.66666667,27.3666667 6.66666667,20 C6.66666667,12.6333333 12.6333333,6.66666667 20,6.66666667 C27.3666667,6.66666667 33.3333333,12.6333333 33.3333333,20 C33.3333333,27.3666667 27.3666667,33.3333333 20,33.3333333 Z",
    id: "\\u5F62\\u72B6",
    fill: "url(#linearGradient-1)",
    fillRule: "nonzero"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotifySuccess);
export default __webpack_public_path__ + "static/media/notify_success.b8f33fe4bde256b0c942232e8e51870c.svg";
export { ForwardRef as ReactComponent };